import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';
import HomeJoinView from './HomeJoinView';

import {
	peersLengthSelector,
	lobbyPeersKeySelector
} from '../../Selectors';
import HomeWaitingView from './HomeWaitingView';
import SerivceName from './SerivceName';

import * as meActions from '../../../actions/meActions';
import * as roomActions from '../../../actions/roomActions';
import * as bottomNavigationActions from '../../../actions/bottomNavigationActions';
import { ROOM_AFK, ROOM_CALLING, ROOM_OFFLINE, ROOM_ONLINE, ROOM_TALKING } from '../../../const';

import { firestore, serverTimestamp } from '../../../lib/firebase';

import ConfirmDialog from '../Common/ConfirmDialog';

const styles = () =>
	({
		root :
		{
			height          : 'calc(100% - 50px)',
			aspectRatio     : 1.777,
			maxWidth        : '96vw',
			minWidth        : 800,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			justifyContent  : 'start'
		},
		rootTalking :
		{
			height          : 'calc(100% - 50px)',
			aspectRatio     : 1.777,
			maxWidth        : '98vw',
			minWidth        : 800,
			position        : 'relative',
			display         : 'flex',
			flexDirection   : 'column',
			borderRadius    : '20px',
			backgroundColor : '#e5e5e2',
			padding         : '1%',
			justifyContent  : 'flex-end'
		}
	});

let roomInfoListener = null;

const Home = ({
	roomClient,
	room,
	user,
	peersLength,
	classes,
	setUser,
	setSettings,
	setRooms,
	setMemos,
	setGroupChats,
	setRoomInfo,
	setCalls,
	lobbyPeers,
	setNaviTab,
	openMemoDialog,
	resetRoom
}) =>
{

	const [ confirmDialogState, setConfirmDialogState ] = useState(
		{
			show    : false,
			title   : '',
			message : ''
		}
	);

	const closeConfirmDialog = () =>
	{
		setConfirmDialogState(
			{
				show    : false,
				title   : '',
				message : ''
			}
		);
	};

	const fetchUser = () =>
	{
		if (user && user.uid)
		{
			firestore.collection('users').doc(user.uid)
				.onSnapshot((querySnapshot) =>
				{
					setUser({
						uid : querySnapshot.id,
						id  : querySnapshot.id,
						...querySnapshot.data()
					});
				});
		}
	};

	const fetchSetting = () =>
	{
		if (user && user.uid)
		{
			firestore.collection('settings').doc(user.uid)
				.onSnapshot((querySnapshot) =>
				{
					setSettings({
						id : querySnapshot.id,
						...querySnapshot.data()
					});
				});
		}
	};

	const fetchRooms = () =>
	{
		if (user && user.uid)
		{
			firestore.collection('rooms')
				.where('uid', '==', user.uid)
				.onSnapshot((snapshot) =>
				{
					const currentRooms = [];

					snapshot.forEach((doc) =>
					{
						currentRooms.push({
							id : doc.id,
							...doc.data()
						});
					});

					currentRooms.sort((a, b) =>
					{
						if (a.index < b.index) { return -1; }
						if (a.index > b.index) { return 1; }

						return 0;
					});

					setRooms(currentRooms);
				});
		}
	};

	const fetchGroupChats = () =>
	{
		if (user && user.uid)
		{
			firestore.collection('chats').where('uid', '==', user.uid)
				.orderBy('timestamp')
				.onSnapshot((snapshot) =>
				{
					const groupChatHistory = [];

					snapshot.forEach((doc) =>
					{
						groupChatHistory.push({
							id : doc.id,
							...doc.data()
						});
					});
					setGroupChats(groupChatHistory);
				});
		}
	};

	const fetchMemos = () =>
	{
		if (user && user.uid)
		{
			firestore.collection('memos').where('uid', '==', user.uid)
				.orderBy('timestamp', 'desc')
				.onSnapshot((snapshot) =>
				{
					const memos = [];

					snapshot.forEach((doc) =>
					{
						memos.push({
							id : doc.id,
							...doc.data()
						});
					});
					setMemos(memos);
				});
		}
	};

	const fetchCalls = () =>
	{
		if (user && user.uid)
		{
			firestore.collection('calls').where('uid', '==', user.uid)
				.orderBy('timestamp', 'desc')
				.onSnapshot((snapshot) =>
				{
					const calls = [];

					snapshot.forEach((doc) =>
					{
						calls.push({
							id : doc.id,
							...doc.data()
						});
					});
					setCalls(calls);
				});
		}
	};

	const fetchRoomInfo = useCallback(() =>
	{
		if (roomInfoListener)
		{
			roomInfoListener();
			roomInfoListener = null;
		}

		if (room.name)
		{
			roomInfoListener = firestore.collection('rooms').doc(room.name)
				.onSnapshot((doc) =>
				{
					if (doc.exists)
					{
						setRoomInfo({
							id : doc.id,
							...doc.data()
						});
					}
				});
		}
		else
		{
			setRoomInfo(null);
		}
	}, [ room.name, setRoomInfo ]);

	const updateStatus = useCallback((status) =>
	{
		if (status === ROOM_TALKING)
		{
			firestore.collection('rooms').doc(room.name)
				.update(
					{
						status       : status,
						lastCalledAt : serverTimestamp()
					}
				);
		}
		else
		{
			firestore.collection('rooms').doc(room.name)
				.update(
					{
						status : status
					}
				);
		}
	}, [ room.name ]);

	useEffect(() =>
	{
		fetchUser();
		fetchSetting();
		fetchRooms();
		fetchGroupChats();
		fetchMemos();
		fetchCalls();
	// eslint-disable-next-line
	}, []);

	useEffect(() =>
	{
		fetchRoomInfo();
	}, [ room.name, fetchRoomInfo ]);

	useEffect(() =>
	{
		roomClient.updateDevices();
	}, [ roomClient ]);

	useEffect(() =>
	{
		if (room.state === 'connected')
		{
			// eslint-disable-next-line no-console
			if (peersLength > 0)
			{
				if (room.info && room.info.status !== ROOM_TALKING)
				{
					updateStatus(ROOM_TALKING);
					setNaviTab('call');
				}
			}
			else if (lobbyPeers.length > 0)
			{
				// updateStatus(ROOM_CALLING);
			}
			// editing memos
			else if (peersLength === 0 && room.memoDialogOpen)
			{
				// updateStatus(ROOM_AFK);
			}
			else if (room.info && room.info.status === ROOM_TALKING)
			{
				updateStatus(ROOM_ONLINE);
				openMemoDialog();
			}
			else if (room.info
				&& room.info.status !== ROOM_ONLINE
				&& room.info.status !== ROOM_AFK)
			{
				updateStatus(ROOM_ONLINE);
			}
		}
		else if (room.state === 'closed')
		{
			updateStatus(ROOM_OFFLINE);
		}

		if (room.info?.forceLeave === true
		&& room.info?.status !== ROOM_TALKING
			&& room.memoDialogOpen !== true)
		{

			setRoomInfo(null);
			setConfirmDialogState({
				show    : true,
				title   : '退室',
				message : '管理者があなたを退室させました。'
			});
			if (room.name)
			{
				firestore.collection('rooms').doc(room.name)
					.update({
						status : 0,
						user   : ''
					});

			}
			roomClient.forceClose();
			resetRoom();
		}
	}, [
		room.state,
		room.info,
		room.name,
		peersLength,
		updateStatus,
		lobbyPeers,
		room.memoDialogOpen,
		setNaviTab,
		openMemoDialog,
		setRoomInfo,
		resetRoom,
		roomClient
	]);

	return (
		<>
			<ConfirmDialog
				show={confirmDialogState.show}
				title={confirmDialogState.title}
				message={confirmDialogState.message}
				accept={() => {}}
				acceptArg={undefined}
				cancel={closeConfirmDialog}
				closeButtonOnly
			/>
			<div className={room.info && room.info.status === ROOM_TALKING ?
				classes.rootTalking : classes.root}
			>
				<SerivceName />
				{ (!room.info || room.info.status === ROOM_OFFLINE) ?
					<HomeJoinView />
					:
					<HomeWaitingView />
				}
			</div>
		</>
	);
};

Home.propTypes =
{
	roomClient                 : PropTypes.object.isRequired,
	user                       : PropTypes.object.isRequired,
	room                       : PropTypes.object.isRequired,
	rooms                      : PropTypes.array.isRequired,
	peersLength                : PropTypes.number.isRequired,
	classes                    : PropTypes.object.isRequired,
	setUser                    : PropTypes.func.isRequired,
	setSettings                : PropTypes.func.isRequired,
	setRooms                   : PropTypes.func.isRequired,
	setMemos                   : PropTypes.func.isRequired,
	setCalls                   : PropTypes.func.isRequired,
	setGroupChats              : PropTypes.func.isRequired,
	setRoomInfo                : PropTypes.func.isRequired,
	setAccessWarningDialogOpen : PropTypes.func.isRequired,
	lobbyPeers                 : PropTypes.array,
	setNaviTab                 : PropTypes.func.isRequired,
	openMemoDialog             : PropTypes.func.isRequired,
	resetRoom                  : PropTypes.func.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		room         : state.room,
		peers        : state.peers,
		peersLength  : peersLengthSelector(state),
		lobbyPeers   : lobbyPeersKeySelector(state),
		loginEnabled : state.me.loginEnabled,
		loggedIn     : state.me.loggedIn,
		locale       : state.intl.locale,
		localesList  : state.intl.list,
		user         : state.me.user,
		settings     : state.me.settings,
		rooms        : state.me.rooms
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setUser : (user) =>
		{
			dispatch(meActions.setUser(user));
		},
		setSettings : (settings) =>
		{
			dispatch(meActions.setSettings(settings));
		},
		setRooms : (rooms) =>
		{
			dispatch(meActions.setRooms(rooms));
		},
		setGroupChats : (groupChatHistory) =>
		{
			dispatch(roomActions.setGroupChats(groupChatHistory));
		},
		setMemos : (memos) =>
		{
			dispatch(roomActions.setMemos(memos));
		},
		setCalls : (calls) =>
		{
			dispatch(roomActions.setCalls(calls));
		},
		setRoomInfo : (info) =>
		{
			dispatch(roomActions.setRoomInfo(info));
		},
		setAccessWarningDialogOpen : (accessWarningDialogOpen) =>
		{
			dispatch(roomActions.setAccessWarningDialogOpen(accessWarningDialogOpen));
		},
		setNaviTab : (tab) =>
		{
			dispatch(bottomNavigationActions.setNaviTab(tab));
		},
		openMemoDialog : () =>
		{
			dispatch(roomActions.setOnMemoDialogOpen(true));
		},
		resetRoom : () =>
		{
			dispatch(roomActions.resetRoom());
		}
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.roomClient === next.roomClient &&
				prev.room === next.room &&
				prev.room.info === next.room.info &&
				prev.settings.displayName === next.settings.displayName &&
				prev.settings === next.settings &&
				prev.me.displayNameInProgress === next.me.displayNameInProgress &&
				prev.me.loginEnabled === next.me.loginEnabled &&
				prev.me.loggedIn === next.me.loggedIn &&
				prev.me.picture === next.me.picture &&
				prev.intl.locale === next.intl.locale &&
				prev.intl.localesList === next.intl.localesList &&
				prev.peers === next.peers &&
				prev.me.user === next.me.user &&
				prev.me.settings === next.me.settings &&
				prev.room.accessWarningDialogOpen === next.room.accessWarningDialogOpen &&
				prev.lobbyPeers === next.lobbyPeers
			);
		}
	}
)(withStyles(styles)(Home)));